import React from 'react'
import Bredcrum from '../../common/Bredcrum'
import CourseFeatures from './course components/CourseFeatures'
import LeftNav from '../../Reusable/LeftNav'
import '../../../assets/styles/aboutcourse.css'
import ClientReviews from './course components/ClientReviews'

import Icon9 from "../../../assets/images/icon-9.png"
import Icon8 from "../../../assets/images/icon-8.png"
import Icon3 from "../../../assets/images/icon-3-corrected.png"
import Shape20 from "../../../assets/images/shape-20.png"
import PurchaseForm from './course components/PurchaseForm'
import { config } from '../config'

const AboutTheoryCourse = () => {
    return (
        <>

            <Bredcrum
                heading={'About Theory Test'}
                path={[
                    { name: 'About Theory Test', path: 'about-theory-test' },
                ]}
            />

            <CourseFeatures />

            <div className=' my-5'>
                <div className='auto-container p-md-5 p-4 pb-4' style={{ backgroundColor: '#f2f2f2' }}>
                    <div className="row">
                        <div className="sec-title ">
                            <h2 className='mb-4 '>Theory Tests Made Easy</h2>
                            <p className='d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                All our theory test products use the official up-to-date theory test revision questions, explanations, and answers from the Driving Vehicle Standards Agency (DVSA), so you can rest assured you’ll be getting all the relevant information you need to pass.
                            </p>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Don't wait any longer to start your journey towards becoming a licensed driver.
                            </p>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Join the thousands who have passed their theory tests with the Driving Test Success app.
                            </p>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                let us help you gain the confidence and skills to pass your theory test with ease.
                            </p>

                            <div className='mt-5'>
                                {/* <LeftNav heading="Purchase Now" btnText={'Purchase Now'} >
                                    <PurchaseForm />
                                </LeftNav> */}
                                <div className="btn-box text-start mt-3">
                                    <a href={`${config.appUrl}book-a-lesson`} className="theme-btn btn-two" type='button' >
                                        Book Now
                                        <i className='bi bi-arrow-right ms-2 fs-6'></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="process-section">
                <div className="auto-container">
                    <div className="row clearfix">
                        {/* <div className="col-lg-6 col-md-12 col-sm-12 left-column">
                            <div className="inner-box">
                                <div className="shape" style={{backgroundImage: `url(${Shape19})`}}></div>
                                <div className="sec-title">
                                    <h2>Start the process</h2>
                                    <p>Denounce with righteous indignation &amp; dislike men who are so beguiled demoralized by hold the charms off pleasure.</p>
                                </div>
                                <div className="image-box">
                                    <figure className="image"><img src={Video} alt="" /></figure>
                                    <div className="video-btn">
                                        <a href="https://www.youtube.com/watch?v=nfP5N9Yc72A&amp;t=28s" className="lightbox-image" data-caption=""><i className="flaticon-play-button-1"></i></a>
                                    </div>
                                </div>
                                <div className="single-item">
                                    <div className="icon"><img src={Icon8} alt="" /></div>
                                    <h3>Get Your First <br />Free Online Lesson Today…</h3>
                                    <p>Schedule your class as your convenient.<a href="#"><i className="flaticon-right-arrow-1"></i>Schedule Now</a></p>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-lg-12 col-md-12 col-sm-12 right-column about_theory">
                            <div className="inner-box">
                                <div className="single-item">
                                    <div className="arrow-shape" style={{ backgroundImage: `url(${Shape20})` }}></div>
                                    <span className="count-text">01</span>
                                    <div className="icon"><img src={Icon9} alt="" /></div>
                                    <h4><a href="#">Multiple Choice Theory</a></h4>
                                    <p>Access to multiple-choice theory questions</p>
                                    <p>Interactive mock tests with case studies</p>
                                    <p>Track your progress with a detailed progress monitor</p>
                                </div>
                                {/* <div className="single-item">
                                    <div className="arrow-shape-2" style={{backgroundImage: `url(${Shape21})`}}></div>
                                    <span className="count-text">02</span>
                                    <div className="icon"><img src={Icon10} alt="" /></div>
                                    <h4><a href="#">Hazard Perception</a></h4>
                                    <p>Access to multiple-choice theory questions</p>
                                    <p>Interactive mock tests with case studies</p>
                                    <p>Track your progress with a detailed progress monitor</p>
                                </div> */}
                                <div className="single-item ms-0">
                                    <div className="arrow-shape" style={{ backgroundImage: `url(${Shape20})` }}></div>
                                    <span className="count-text">02</span>
                                    <div className="icon"><img src={Icon8} alt="" /></div>
                                    <h4><a href="#">Hazard Perception</a></h4>
                                    <p>Access to multiple-choice theory questions</p>
                                    <p>Interactive mock tests with case studies</p>
                                    <p>Track your progress with a detailed progress monitor</p>
                                </div>
                                <div className="single-item ms-0">
                                    <div className="arrow-shape" style={{ backgroundImage: `url(${Shape20})` }}></div>
                                    <span className="count-text">03</span>
                                    <div className="icon"><img src={Icon3} alt="" /></div>
                                    <h4><a href="#">Practical</a></h4>
                                    <p>Access to multiple-choice theory questions</p>
                                    <p>Interactive mock tests with case studies</p>
                                    <p>Track your progress with a detailed progress monitor</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <ClientReviews />
        </>
    )
}

export default AboutTheoryCourse